module.exports = __webpack_public_path__ + "static/media/goblin_boots.ebcbec6e.png";